import styled from 'styled-components';
import Theme from '../../../../styles/models/theme';

export const Container = styled.button<{
  backgroundColor?: string;
  shadowColor?: string;
  disabled?: boolean;
  validation?: boolean;
  theme: Theme;
}>`
  background-color: ${({backgroundColor, theme}) =>
    backgroundColor || theme.primary};
  height: 48px;
  border-radius: 100px;
  padding: 12px;
  justify-content: center;
  opacity: ${({disabled, validation}) =>
    disabled || (validation != null && !validation) ? 0.5 : 1};
  border-width: 0px;

  &:active {
    transform: scale(0.99);
    opacity: 0.8;
  }
`;

export const Title = styled.text<{color?: string; theme: any}>`
  color: ${({color, theme}) => color || theme.lightText};
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
`;
